/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */

import Vue from 'vue';
import axios from 'axios'

export default {
  API: {
    CUSTOMER_BEHAVIOUR_BUILD_INTENT_TO_LIVE_AGENT_HANDLING: '/customerBehavior/liveAgentHandling',
    CUSTOMER_BEHAVIOUR_FETCH_FILTERS: '/chatAnalytics/chatFilters',
    CUSTOMER_BEHAVIOUR_BUILD_INTENT_TO_CUSTOMER_FEEDBACK_CHART: '/customerBehavior/customerFeedback',
    CUSTOMER_BUILD_INTENT_TO_CONVERSATIONS_BY_DEVICES_CHART: '/customerBehavior/conversationsByDevices',
    CUSTOMER_BUILD_INTENT_TO_CONVERSATIONS_BY_CHANNELS_CHART: '/customerBehavior/conversationsByChannels',
    CUSTOMER_BUILD_NEW_AND_RETURNING_USERS: '/customerBehavior/newAndReturningConversations',
    CUSTOMER_BUILD_USAGE_PER_CUSTOMER: '/customerBehavior/usagePerCustomer',
    CUSTOMER_BUILD_CUSTOMER_LOCATION: '/customerBehavior/customerLocation',
    CUSTOMER_BUILD_RESPONSE_FEEDBACK: '/customerBehavior/responseFeedback'
  },
  
  cachedHash: {},
  cancelTokens: [],

  getRequest(authUser, url, headers) {
    if(authUser.accessToken) {
      if(headers == null) headers = {};
      headers["Authorization"] = "Bearer " + authUser.accessToken;
      headers["Api-Configs"] = JSON.stringify(authUser.config.api.configs);

      return axios.get(url, {headers: headers, timeout: 300000});
    }
    else {
      return null;
    }
  },

  postRequest(authUser, url, payload, headers) {
    if(authUser.accessToken) {
      if(headers == null) headers = {};
      headers["Authorization"] = "Bearer " + authUser.accessToken;
      headers["Api-Configs"] = JSON.stringify(authUser.config.api.configs);

      let cancelTokenKey = url;
      if(this.cancelTokens[cancelTokenKey]) {
        // cancel request
        this.cancelTokens[cancelTokenKey].cancel();
      }
      this.cancelTokens[cancelTokenKey] = axios.CancelToken.source();

      let options = {
        timeout: 300000, // timeout in 5 mins
        headers: headers,
        cancelToken: this.cancelTokens[cancelTokenKey].token
      }

      return axios.post(url, payload, options);
    }
    else {
      return null;
    }
  },

  fetchFilters(authUser) {
    let url = Vue.WyConstants.SERVER.CUSTOMER_HOST + this.API.CUSTOMER_BEHAVIOUR_FETCH_FILTERS;
    return this.getRequest(authUser, url);
  },

  fetchIntentToCustomerFeedbackChartData(authUser, payload) {
    let url = Vue.WyConstants.SERVER.CUSTOMER_HOST + this.API.CUSTOMER_BEHAVIOUR_BUILD_INTENT_TO_CUSTOMER_FEEDBACK_CHART;
    return this.postRequest(authUser, url, payload);
  },

  fetchIntentToLiveAgentHandlingChartData(authUser, payload) {
    let url = Vue.WyConstants.SERVER.CUSTOMER_HOST + this.API.CUSTOMER_BEHAVIOUR_BUILD_INTENT_TO_LIVE_AGENT_HANDLING;
    return this.postRequest(authUser, url, payload);
  },

  fetchIntentToCustomerByDevicesChartData(authUser, payload) {
    let url = Vue.WyConstants.SERVER.CUSTOMER_HOST + this.API.CUSTOMER_BUILD_INTENT_TO_CONVERSATIONS_BY_DEVICES_CHART;
    return this.postRequest(authUser, url, payload);
  },

  fetchIntentToCustomerByChannelsChartData(authUser, payload) {
    let url = Vue.WyConstants.SERVER.CUSTOMER_HOST + this.API.CUSTOMER_BUILD_INTENT_TO_CONVERSATIONS_BY_CHANNELS_CHART;
    return this.postRequest(authUser, url, payload);
  },

  fetchNewAndReturningUsers(authUser, payload) {
    let url = Vue.WyConstants.SERVER.CUSTOMER_HOST + this.API.CUSTOMER_BUILD_NEW_AND_RETURNING_USERS;
    return this.postRequest(authUser, url, payload);
  },

  fetchUsagePerCustomer(authUser, payload) {
    let url = Vue.WyConstants.SERVER.CUSTOMER_HOST + this.API.CUSTOMER_BUILD_USAGE_PER_CUSTOMER;
    return this.postRequest(authUser, url, payload);
  },

  fetchCustomerLocationData(authUser, payload){
    let url = Vue.WyConstants.SERVER.CUSTOMER_HOST + this.API.CUSTOMER_BUILD_CUSTOMER_LOCATION;
    return this.postRequest(authUser, url, payload);
  },

  fetchJourneyAndResponseFeedback(authUser, payload){
    let url = Vue.WyConstants.SERVER.CUSTOMER_HOST + this.API.CUSTOMER_BUILD_RESPONSE_FEEDBACK;
    return this.postRequest(authUser, url, payload);
  }
}